export const MOTION_TABLE = {
    MALE_MOTION: 0, // STR
    FEMALE_MOTION: 1, // STR
    MOTION_TYPE: 2, // INT
    DESCRIPTION: 3, // STR
};

export const AVTANI = {
    STOP1: 0,
    STOP2: 1,
    WALK: 2,
    RUN: 3,
    SITTING: 4,
    SIT: 5,
    STANDUP: 6,
    STOP3: 7,
    ATTACK: 8,
    ATTACK2: 9,
    ATTACK3: 10,
    HIT: 11,
    FALL: 12,
    DIE: 13,
    RAISE: 14,
    JUMP1: 15,
    JUMP2: 16,
    PICKITEM: 17,
    KISS: 21,
    BOW: 22,
    CHEER: 23,
    BOW2: 24,
    CLAP: 25,
    LAUGH: 26,
    CHEER2: 27,
    FRUSTRATION: 28,
    SHOW_X: 29,
    KNEEL: 30,
    BOW3: 31,
    TROUBLE: 32,
    DANCE: 41,
    DANCE1: 51,
    DANCE2: 52,
    DANCE3: 53,
    DANCE4: 54,
    DANCE5: 55,
    DANCE6: 56,
    DANCE7: 57,
    DANCE8: 58,
    DANCE9: 59,
    DANCE10: 60,
    DANCE11: 61,
    DANCE12: 62,
    DANCE13: 63,
    DANCE14: 64,
    PICKUP: 72,
    NARSIS_SKILL01: 75,
    SNOW_FIRING: 76,
};

export const AVTBODYPART = {
    Face: 0,
    Hair: 1,
    Cap: 2,
    Body: 3,
    Arms: 4,
    Foot: 5,
    FaceItem: 6,
    Back: 7,
    Weapon: 8,
    SubWeapon: 9,
    Max: 10,
};

export const AVTRIDEPART = {
    Max: 5,
};

export const AVTSHOTTYPE = {
    Max: 3,
};

export const BoneIndex = {
    Pelvis: 0,
    Head: 4,
};

export const DummyIndex = {
    RightHand: 0,
    LeftHand: 1,
    LeftHandShield: 2,
    Back: 3,
    Mouse: 4,
    Eyes: 5,
    Cap: 6,
};

export const DEFAULT_ATTACK_DISTANCE = 0.7;

export let debugBoundingBoxes = false;
export function setDebugBoundingBoxes(value: boolean) {
    debugBoundingBoxes = value;
}

// ponytail: temporarily disabled per request, re-enable by flipping this back to true
export let itemDropBounceEnabled = false;
export function setItemDropBounceEnabled(value: boolean) {
    itemDropBounceEnabled = value;
}

export const VIRTUAL_FUNC = function (..._args: any[]) {
    throw new Error("Pure virtual function was invoked");
};
